export const AUTH = {
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  loginSubmit: "login-submit-button",
  mfaCodeInput: "mfa-code-input",
  mfaSubmit: "mfa-submit-button",
  loginError: "login-error-message",
  forgotPasswordLink: "forgot-password-link",
  resetEmailInput: "reset-email-input",
  resetSubmit: "reset-submit-button",
  resetMessage: "reset-message",
  resetTokenInput: "reset-token-input",
  resetNewPasswordInput: "reset-new-password-input",
  resetConfirmPasswordInput: "reset-confirm-password-input",
  resetConfirmSubmit: "reset-confirm-submit-button",
  resetBackToLogin: "reset-back-to-login-link",
  // DEFECT-D-04: forced temp-password change screen (trial self-signup)
  newPasswordInput: "force-new-password-input",
  confirmPasswordInput: "force-confirm-password-input",
  forcePasswordSubmit: "force-password-submit-button",
};

export const DASHBOARD = {
  logoutButton: "logout-button",
  meInfo: "me-info-panel",
  branchesList: "branches-list",
  staffList: "staff-list",
  entitlementsList: "entitlements-list",
  newBranchNameInput: "new-branch-name-input",
  newBranchSubmit: "new-branch-submit-button",
  newStaffNameInput: "new-staff-name-input",
  newStaffEmailInput: "new-staff-email-input",
  newStaffPasswordInput: "new-staff-password-input",
  newStaffRoleInput: "new-staff-role-input",
  newStaffSubmit: "new-staff-submit-button",
  dashboardError: "dashboard-error-message",
};

export const KAIROO_AUTH = {
  emailInput: "kairoo-login-email-input",
  passwordInput: "kairoo-login-password-input",
  loginSubmit: "kairoo-login-submit-button",
  mfaCodeInput: "kairoo-mfa-code-input",
  mfaSubmit: "kairoo-mfa-submit-button",
  loginError: "kairoo-login-error-message",
};

export const CONTROL = {
  sidebar: "control-sidebar",
  navItem: (key) => `control-nav-item-${key}`,
  logoMark: "control-logo-mark",
  topBar: "control-top-bar",
  searchInput: "control-search-input",
  searchResultRow: (id) => `control-search-result-${id}`,
  envIndicator: "control-env-indicator",
  avatarMenuTrigger: "control-avatar-menu-trigger",
  avatarMenuLogout: "control-avatar-menu-logout-item",

  dashboardPage: "control-dashboard-page",
  kpiCard: (key) => `control-kpi-card-${key}`,
  revenuePanel: "control-revenue-panel",
  atRiskPanel: "control-at-risk-panel",
  atRiskRow: (orgId) => `control-at-risk-row-${orgId}`,
  healthStrip: "control-health-strip",
  // DEFECT-D-19 to D-23: chart-based dashboard additions.
  gymsByStatusChart: "control-gyms-by-status-chart",
  newGymsTrendChart: "control-new-gyms-trend-chart",
  trialsPanel: "control-trials-panel",
  trialConvertButton: (orgId) => `control-trial-convert-button-${orgId}`,
  churnedPanel: "control-churned-panel",
  additionalKpiCard: (key) => `control-additional-kpi-card-${key}`,

  gymsPage: "control-gyms-page",
  gymsTable: "control-gyms-table",
  gymRow: (orgId) => `control-gym-row-${orgId}`,
  statusFilter: "control-status-filter-trigger",
  gymsSortControl: "control-gyms-sort-control",
  provisionButton: "control-provision-button",

  provisionDialog: "control-provision-dialog",
  provisionOrgNameInput: "control-provision-org-name-input",
  provisionAdminNameInput: "control-provision-admin-name-input",
  provisionAdminEmailInput: "control-provision-admin-email-input",
  provisionAdminPasswordInput: "control-provision-admin-password-input",
  provisionSeatLimitInput: "control-provision-seat-limit-input",
  provisionBillingAmountInput: "control-provision-billing-amount-input",
  provisionBillingCycleSelect: "control-provision-billing-cycle-select",
  provisionNextBillingInput: "control-provision-next-billing-input",
  provisionBranchInput: (i) => `control-provision-branch-input-${i}`,
  provisionAddBranch: "control-provision-add-branch-button",
  provisionSubmit: "control-provision-submit-button",
  provisionError: "control-provision-error",

  gymDetailPage: "control-gym-detail-page",
  tabOverview: "control-tab-overview",
  tabModules: "control-tab-modules",
  tabSeatsLicense: "control-tab-seats-license",
  tabSuspend: "control-tab-suspend",
  tabAudit: "control-tab-audit",
  auditSearchInput: "control-audit-search-input",
  auditTable: "control-audit-table",
  auditRow: (id) => `control-audit-row-${id}`,
  auditEmptyState: "control-audit-empty-state",
  moduleToggle: (module) => `control-module-toggle-${module}`,
  seatLimitInput: "control-seat-limit-input",
  seatLimitSave: "control-seat-limit-save-button",
  licenseStateBadge: "control-license-state-badge",
  suspendButton: "control-suspend-button",
  restoreButton: "control-restore-button",
  suspendConfirmDialog: "control-suspend-confirm-dialog",
  suspendConfirmInput: "control-suspend-confirm-input",
  suspendConfirmSubmit: "control-suspend-confirm-submit-button",
  // DEFECT-D-06/D-07: true "block all logins" gym suspend + irreversible delete — distinct from
  // the billing read-only hold above (which deliberately still allows login).
  gymSuspendButton: "control-gym-suspend-button",
  gymUnsuspendButton: "control-gym-unsuspend-button",
  gymSuspendDialog: "control-gym-suspend-dialog",
  gymSuspendReasonInput: "control-gym-suspend-reason-input",
  gymSuspendConfirmButton: "control-gym-suspend-confirm-button",
  gymDeleteButton: "control-gym-delete-button",
  gymDeleteDialog: "control-gym-delete-dialog",
  gymDeleteConfirmInput: "control-gym-delete-confirm-input",
  gymDeleteConfirmButton: "control-gym-delete-confirm-button",
  gymDeletePreview: "control-gym-delete-preview",
  gymDeleteForceCheckbox: "control-gym-delete-force-checkbox",
  gymRestoreButton: "control-gym-restore-button",
  billingAmountInput: "control-billing-amount-input",
  billingCycleSelect: "control-billing-cycle-select",
  billingNextDateInput: "control-billing-next-date-input",
  billingSaveButton: "control-billing-save-button",
  gymNotesInput: "control-gym-notes-input",
  gymNotesSaveButton: "control-gym-notes-save-button",
  gymNameEditButton: "control-gym-name-edit-button",
  gymNameInput: "control-gym-name-input",
  gymNameSaveButton: "control-gym-name-save-button",
  gymNameCancelButton: "control-gym-name-cancel-button",
  gymOwnerEditButton: "control-gym-owner-edit-button",
  gymOwnerNameInput: "control-gym-owner-name-input",
  gymOwnerEmailInput: "control-gym-owner-email-input",
  gymOwnerPhoneInput: "control-gym-owner-phone-input",
  gymOwnerCityInput: "control-gym-owner-city-input",
  gymOwnerSaveButton: "control-gym-owner-save-button",
  gymOwnerCancelButton: "control-gym-owner-cancel-button",

  trialsPage: "control-trials-page",
  trialsQueueTable: "control-trials-queue-table",
  trialRow: (id) => `control-trial-row-${id}`,
  trialApproveButton: (id) => `control-trial-approve-button-${id}`,
  trialDenyButton: (id) => `control-trial-deny-button-${id}`,
  trialDenyDialog: "control-trial-deny-dialog",
  trialDenyReasonInput: "control-trial-deny-reason-input",
  trialDenyConfirm: "control-trial-deny-confirm-button",
  trialConfigPlatformInput: "control-trial-config-platform-input",
  trialConfigPerSignalInput: "control-trial-config-per-signal-input",
  trialConfigSaveButton: "control-trial-config-save-button",
};

// UX-TRIAL — public trial signup form (mounted on /login) + the global block modal/status
// badge/demo-preview banner it drives inside the gym shell.
export const TRIAL = {
  startTrialLink: "start-trial-link",
  backToLoginLink: "trial-back-to-login-link",
  gymNameInput: "trial-gym-name-input",
  ownerNameInput: "trial-owner-name-input",
  phoneInput: "trial-phone-input",
  emailInput: "trial-email-input",
  cityInput: "trial-city-input",
  honeypotInput: "trial-honeypot-website-input",
  submitButton: "trial-signup-submit-button",
  error: "trial-signup-error",
  resultMessage: "trial-signup-result-message",
  continueButton: "trial-signup-continue-button",
  explorePreviewButton: "trial-signup-explore-preview-button",

  demoPreviewBanner: "trial-demo-preview-banner",
  statusBadge: "trial-status-badge",
  blockModal: "trial-block-modal",
  blockModalContact: "trial-block-modal-contact-button",
  blockModalContinue: "trial-block-modal-continue-button",
};

// UX-FD-01 — Front Desk shell + all its screens (public route namespace /desk/*).
export const DESK = {
  shell: "desk-shell",
  branchName: "desk-branch-name",
  logoutButton: "desk-logout-button",
  navItem: (key) => `desk-nav-${key}`,
  globalSearchInput: "desk-global-search-input",

  todayPage: "desk-today-page",
  quickActionCard: (key) => `desk-quick-action-${key}`,
  statCurrentlyIn: "desk-stat-currently-in",
  statCollectedToday: "desk-stat-collected-today",
  atRiskList: "desk-at-risk-list",
  duesList: "desk-dues-list",
  trialsDueList: "desk-trials-due-list",

  shiftPage: "desk-shift-page",
  clockInButton: "desk-clock-in-button",
  clockStatus: "desk-clock-status",
  floatAmountInput: "desk-float-amount-input",
  openDrawerButton: "desk-open-drawer-button",
  drawerStatus: "desk-drawer-status",

  memberLookupPage: "desk-member-lookup-page",
  memberSearchInput: "desk-member-search-input",
  memberSearchButton: "desk-member-search-button",
  memberFilterTab: (key) => `desk-member-filter-${key}`,
  memberEmptyState: "desk-member-empty-state",
  memberRow: (id) => `desk-member-row-${id}`,
  memberViewButton: (id) => `desk-member-view-button-${id}`,
  memberReactivateButton: (id) => `desk-member-reactivate-button-${id}`,
  newMemberButton: "desk-new-member-button",

  walkinPage: "desk-walkin-page",
  walkinNameInput: "desk-walkin-name-input",
  walkinPhoneInput: "desk-walkin-phone-input",
  walkinEmailInput: "desk-walkin-email-input",
  walkinNextButton: "desk-walkin-next-button",
  walkinError: "desk-walkin-error",
  walkinExistingFound: "desk-walkin-existing-found",
  walkinGoReactivate: "desk-walkin-go-reactivate-button",
  walkinBranchSelect: "desk-walkin-branch-select",
  walkinPlanSelect: "desk-walkin-plan-select",
  walkinStartDateInput: "desk-walkin-start-date-input",
  walkinDiscountInput: "desk-walkin-discount-input",
  walkinPlanNextButton: "desk-walkin-plan-next-button",
  walkinPaymentMode: "desk-walkin-payment-mode",
  walkinTxnRefInput: "desk-walkin-txn-ref-input",
  walkinPaymentAmount: "desk-walkin-payment-amount-input",
  walkinNetPayable: "desk-walkin-net-payable",
  walkinOutstandingBalance: "desk-walkin-outstanding-balance",
  walkinPaymentSubmit: "desk-walkin-payment-submit-button",
  walkinInvoiceButton: "desk-walkin-invoice-button",
  walkinPaymentContinueButton: "desk-walkin-payment-continue-button",
  walkinDone: "desk-walkin-done",
  walkinDoneContinue: "desk-walkin-done-continue-button",

  // Shared "Personal details" fields (Walk-in step 1 + Add Family "new person" branch)
  memberPhotoInput: "desk-member-photo-input",
  memberPhotoPreview: "desk-member-photo-preview",
  memberWhatsappInput: "desk-member-whatsapp-input",
  memberDobInput: "desk-member-dob-input",
  memberGenderPill: (g) => `desk-member-gender-${g}`,
  memberBloodGroupSelect: "desk-member-blood-group-select",
  memberAlternateMobileInput: "desk-member-alternate-mobile-input",
  memberOccupationInput: "desk-member-occupation-input",
  emergencyNameInput: "desk-emergency-name-input",
  emergencyRelationshipSelect: "desk-emergency-relationship-select",
  emergencyMobileInput: "desk-emergency-mobile-input",
  emergencyAltMobileInput: "desk-emergency-alt-mobile-input",
  kycAadhaarInput: "desk-kyc-aadhaar-input",
  kycPanInput: "desk-kyc-pan-input",
  kycOtherDocTypeSelect: "desk-kyc-other-doc-type-select",
  kycOtherDocNumberInput: "desk-kyc-other-doc-number-input",

  // Walk-in step 3 — Health & Goals
  walkinHealthPage: "desk-walkin-health-page",
  fitnessGoalPill: (g) => `desk-fitness-goal-${g}`,
  fitnessLevelPill: (l) => `desk-fitness-level-${l}`,
  medicalHistoryInput: "desk-medical-history-input",
  medicalConditionPill: (c) => `desk-medical-condition-${c}`,
  currentMedicationsInput: "desk-current-medications-input",
  knownAllergiesInput: "desk-known-allergies-input",
  prevGymExperienceSelect: "desk-prev-gym-experience-select",
  preferredWorkoutTimeSelect: "desk-preferred-workout-time-select",
  referralSourceSelect: "desk-referral-source-select",
  enrollMemberButton: "desk-enroll-member-button",
  enrollMemberSkipButton: "desk-enroll-member-skip-button",

  memberDetailPage: "desk-member-detail-page",
  memberEditButton: "desk-member-edit-button",
  memberSuspendButton: "desk-member-suspend-button",
  memberUnsuspendButton: "desk-member-unsuspend-button",
  memberSuspendDialog: "desk-member-suspend-dialog",
  memberSuspendReasonInput: "desk-member-suspend-reason-input",
  memberSuspendConfirmButton: "desk-member-suspend-confirm-button",
  memberLedgerTable: "desk-member-ledger-table",
  memberRenewButton: "desk-member-renew-button",
  memberFreezeButton: "desk-member-freeze-button",
  memberResumeButton: "desk-member-resume-button",
  memberReactivateOpenButton: "desk-member-reactivate-open-button",
  memberAddFamilyButton: "desk-member-add-family-button",
  memberAddPlanButton: "desk-member-add-plan-button",
  memberBookClassButton: "desk-member-book-class-button",
  memberBookClassDialog: "desk-member-book-class-dialog",
  memberBookClassSelect: "desk-member-book-class-select",
  memberBookClassConfirmButton: "desk-member-book-class-confirm-button",
  membershipRow: (id) => `desk-membership-row-${id}`,
  addPlanSelect: "desk-add-plan-select",
  addPlanDiscountInput: "desk-add-plan-discount-input",
  addPlanSubmitButton: "desk-add-plan-submit-button",
  ledgerGenerateInvoiceButton: (id) => `desk-ledger-generate-invoice-${id}`,
  ledgerDownloadInvoiceButton: (id) => `desk-ledger-download-invoice-${id}`,
  moneyGenerateInvoiceButton: "desk-money-generate-invoice-button",

  editNameInput: "desk-edit-name-input",
  editEmailInput: "desk-edit-email-input",
  editNoteInput: "desk-edit-note-input",
  editSaveButton: "desk-edit-save-button",

  reactivatePlanSelect: "desk-reactivate-plan-select",
  reactivateStartInput: "desk-reactivate-start-input",
  reactivateSubmitButton: "desk-reactivate-submit-button",

  renewSubmitButton: "desk-renew-submit-button",
  changePlanSelect: "desk-change-plan-select",
  changePlanSubmitButton: "desk-change-plan-submit-button",

  familyMemberInput: "desk-family-member-input",
  familySubmitButton: "desk-family-submit-button",
  familyNewNameInput: "desk-family-new-name-input",
  familyStep: (n) => `desk-family-step-${n}`,
  familyPlanSelect: "desk-family-plan-select",
  familyStartDateInput: "desk-family-start-date-input",
  familyDiscountInput: "desk-family-discount-input",
  familyPlanNextButton: "desk-family-plan-next-button",
  familySkipPlanButton: "desk-family-skip-plan-button",
  familyPaymentMode: "desk-family-payment-mode",
  familyTxnRefInput: "desk-family-txn-ref-input",
  familyPaymentAmount: "desk-family-payment-amount-input",
  familyNetPayable: "desk-family-net-payable",
  familyOutstandingBalance: "desk-family-outstanding-balance",
  familyPaymentSubmit: "desk-family-payment-submit-button",
  familyInvoiceButton: "desk-family-invoice-button",
  familyPaymentContinueButton: "desk-family-payment-continue-button",

  checkinPage: "desk-checkin-page",
  checkinSearchInput: "desk-checkin-search-input",
  checkinButton: (id) => `desk-checkin-button-${id}`,
  checkinResult: "desk-checkin-result",
  checkinOverrideButton: "desk-checkin-override-button",
  checkinOverrideReasonInput: "desk-checkin-override-reason-input",
  checkinOverrideSubmit: "desk-checkin-override-submit-button",
  guestNameInput: "desk-guest-name-input",
  guestCheckinButton: "desk-guest-checkin-button",
  scanMemberButton: "desk-scan-member-button",
  showGymCodeButton: "desk-show-gym-code-button",
  gymCodePanel: "desk-gym-code-panel",
  gymCodePin: "desk-gym-code-pin",

  moneyPage: "desk-money-page",
  moneySearchInput: "desk-money-search-input",
  moneyBalanceCard: "desk-money-balance-card",
  paymentAmountInput: "desk-payment-amount-input",
  paymentModeSelect: "desk-payment-mode-select",
  paymentSubmitButton: "desk-payment-submit-button",
  collectDueButton: "desk-collect-due-button",
  mandateProviderInput: "desk-mandate-provider-input",
  mandateCreateButton: "desk-mandate-create-button",

  readOnlyBanner: "desk-read-only-banner",

  retailPage: "desk-retail-page",
  retailProductSearchInput: "desk-retail-product-search-input",
  retailProductCard: (id) => `desk-retail-product-card-${id}`,
  retailCartItem: (id) => `desk-retail-cart-item-${id}`,
  retailPaymentMode: "desk-retail-payment-mode",
  retailRailRefInput: "desk-retail-rail-ref-input",
  retailCheckoutButton: "desk-retail-checkout-button",
  retailReceipt: "desk-retail-receipt",
  retailSoldOutMessage: "desk-retail-sold-out-message",
  retailTab: (key) => `desk-retail-tab-${key}`,
  retailSaleRow: (id) => `desk-retail-sale-row-${id}`,
  retailRefundButton: (id) => `desk-retail-refund-button-${id}`,
  retailRefundReasonInput: "desk-retail-refund-reason-input",
  retailRefundRestockCheckbox: "desk-retail-refund-restock-checkbox",
  retailRefundSubmit: "desk-retail-refund-submit-button",

  floorOpsPage: "desk-floor-ops-page",
  pettyAmountInput: "desk-petty-amount-input",
  pettyNoteInput: "desk-petty-note-input",
  pettySubmitButton: "desk-petty-submit-button",
  lockerKindInput: "desk-locker-kind-input",
  lockerAssignButton: "desk-locker-assign-button",
  assetKindInput: "desk-asset-kind-input",
  assetIssueButton: "desk-asset-issue-button",
  incidentNotAvailable: "desk-incident-not-available",

  handoverOpenButton: "desk-handover-open-button",
  handoverCountedInput: "desk-handover-counted-input",
  handoverToInput: "desk-handover-to-input",
  handoverSubmit: "desk-handover-submit-button",
  handoverResult: "desk-handover-result",
  handoverMismatchFlag: "desk-handover-mismatch-flag",

  // UX-FD-03 — Manager Tier: its own sub-shell (`/desk/mgr/*`, tabs) + all 9 screens.
  mgrTab: (key) => `desk-mgr-tab-${key}`,

  mgrDashboardPage: "desk-mgr-dashboard-page",
  mgrRevenueStat: "desk-mgr-revenue-stat",
  mgrExpenseStat: "desk-mgr-expense-stat",
  mgrProfitStat: "desk-mgr-profit-stat",
  mgrLeakageStat: "desk-mgr-leakage-stat",
  mgrOccupancyStat: "desk-mgr-occupancy-stat",

  mgrExpensePage: "desk-mgr-expense-page",
  mgrExpenseCategorySelect: "desk-mgr-expense-category-select",
  mgrExpenseAmountInput: "desk-mgr-expense-amount-input",
  mgrExpensePaidFromSelect: "desk-mgr-expense-paid-from-select",
  mgrExpenseNoteInput: "desk-mgr-expense-note-input",
  mgrExpenseAttachmentInput: "desk-mgr-expense-attachment-input",
  mgrExpenseSubmitButton: "desk-mgr-expense-submit-button",
  mgrExpenseRow: (id) => `desk-mgr-expense-row-${id}`,

  mgrPayoutPage: "desk-mgr-payout-page",
  mgrPayoutPeriodStartInput: "desk-mgr-payout-period-start-input",
  mgrPayoutPeriodEndInput: "desk-mgr-payout-period-end-input",
  mgrPayoutRunButton: "desk-mgr-payout-run-button",
  mgrPayoutResult: "desk-mgr-payout-result",
  mgrPayoutAlreadyPaidMessage: "desk-mgr-payout-already-paid-message",
  mgrPayoutStatementRow: (ref) => `desk-mgr-payout-statement-row-${ref}`,

  mgrRefundPage: "desk-mgr-refund-page",
  mgrRefundSearchInput: "desk-mgr-refund-search-input",
  mgrRefundSearchButton: "desk-mgr-refund-search-button",
  mgrRefundMemberRow: (id) => `desk-mgr-refund-member-row-${id}`,
  mgrRefundEntryRow: (id) => `desk-mgr-refund-entry-row-${id}`,
  mgrRefundButton: (id) => `desk-mgr-refund-button-${id}`,
  mgrRefundAmountInput: "desk-mgr-refund-amount-input",
  mgrRefundReasonInput: "desk-mgr-refund-reason-input",
  mgrRefundConfirmInput: "desk-mgr-refund-confirm-input",
  mgrRefundConfirmSubmit: "desk-mgr-refund-confirm-submit-button",

  mgrDayEndPage: "desk-mgr-day-end-page",
  mgrDayEndDateInput: "desk-mgr-day-end-date-input",
  mgrDayEndLoadButton: "desk-mgr-day-end-load-button",
  mgrDayEndMismatchFlag: "desk-mgr-day-end-mismatch-flag",
  mgrDayEndShiftRow: (id) => `desk-mgr-day-end-shift-row-${id}`,

  mgrRosterPage: "desk-mgr-roster-page",
  mgrRosterOnShiftList: "desk-mgr-roster-on-shift-list",
  mgrRosterProviderInput: "desk-mgr-roster-provider-input",
  mgrRosterLoadButton: "desk-mgr-roster-load-button",
  mgrRosterWindowRow: (i) => `desk-mgr-roster-window-row-${i}`,
  mgrRosterDayInput: "desk-mgr-roster-day-input",
  mgrRosterStartInput: "desk-mgr-roster-start-input",
  mgrRosterEndInput: "desk-mgr-roster-end-input",
  mgrRosterAddWindowButton: "desk-mgr-roster-add-window-button",
  mgrRosterSaveButton: "desk-mgr-roster-save-button",

  mgrPerformancePage: "desk-mgr-performance-page",
  mgrPerformanceProviderInput: "desk-mgr-performance-provider-input",
  mgrPerformanceLoadButton: "desk-mgr-performance-load-button",
  mgrPerformanceAttendedStat: "desk-mgr-performance-attended-stat",
  mgrPerformanceNoShowStat: "desk-mgr-performance-no-show-stat",
  mgrPerformanceRetentionStat: "desk-mgr-performance-retention-stat",

  mgrOffersPage: "desk-mgr-offers-page",
  mgrOfferCodeInput: "desk-mgr-offer-code-input",
  mgrOfferDiscountInput: "desk-mgr-offer-discount-input",
  mgrOfferStartInput: "desk-mgr-offer-start-input",
  mgrOfferEndInput: "desk-mgr-offer-end-input",
  mgrOfferSubmitButton: "desk-mgr-offer-submit-button",
  mgrOfferRow: (code) => `desk-mgr-offer-row-${code}`,

  mgrStockPage: "desk-mgr-stock-page",
  mgrStockRow: (id) => `desk-mgr-stock-row-${id}`,
  mgrStockDeltaInput: (id) => `desk-mgr-stock-delta-input-${id}`,
  mgrStockReasonInput: (id) => `desk-mgr-stock-reason-input-${id}`,
  mgrStockAdjustButton: (id) => `desk-mgr-stock-adjust-button-${id}`,

  mgrGovernancePage: "desk-mgr-governance-page",
  mgrStaffNotAvailable: "desk-mgr-staff-not-available",
  mgrDeviceNotAvailable: "desk-mgr-device-not-available",
  mgrIncidentNotAvailable: "desk-mgr-incident-not-available",
  mgrAuditNotAvailable: "desk-mgr-audit-not-available",
};

export const HOME = {
  emergentLink: "emergent-link",
};

export const MONETIZATION = {
  page: "monetization-page",
  forbidden: "monetization-forbidden",
  billingTable: "monetization-billing-table",
  takeRateGymSelect: "monetization-take-rate-gym-select",
  takeRateCurrentValue: "monetization-take-rate-current-value",
  takeRateFlatFeeInput: "monetization-take-rate-flat-fee-input",
  takeRateFloorInput: "monetization-take-rate-floor-input",
  takeRateSaveButton: "monetization-take-rate-save-button",
  settlementPeriodInput: "monetization-settlement-period-input",
  settlementRunButton: "monetization-settlement-run-button",
  settlementResultsTable: "monetization-settlement-results-table",
};

export const INTEGRATIONS = {
  page: "integrations-page",
  gymSelect: "integrations-gym-select",
  configsTable: "integrations-configs-table",
  testButton: (id) => `integrations-test-button-${id}`,
  rotateButton: (id) => `integrations-rotate-button-${id}`,
  rotateDialog: "integrations-rotate-dialog",
  rotateInput: "integrations-rotate-input",
  rotateAccessTokenInput: "integrations-rotate-access-token-input",
  rotateAppSecretInput: "integrations-rotate-app-secret-input",
  rotateSubmit: "integrations-rotate-submit-button",
  connectWhatsappButton: "integrations-connect-whatsapp-button",
  connectWhatsappDialog: "integrations-connect-whatsapp-dialog",
  connectDisplayNameInput: "integrations-connect-display-name-input",
  connectFromAddressInput: "integrations-connect-from-address-input",
  connectWabaIdInput: "integrations-connect-waba-id-input",
  connectPhoneNumberIdInput: "integrations-connect-phone-number-id-input",
  connectAccessTokenInput: "integrations-connect-access-token-input",
  connectAppSecretInput: "integrations-connect-app-secret-input",
  connectSubmit: "integrations-connect-submit-button",
  paymentProviderCard: "integrations-payment-provider-card",
  paymentProviderConnectButton: "integrations-payment-provider-connect-button",
};

// UX-CP-02 §2 — mirrors backend VALID_KAIROO_PERMISSIONS (models.py) exactly; a static list is
// fine here (no network round-trip needed for a fixed, rarely-changing vocabulary).
export const VALID_KAIROO_PERMISSIONS = ["provision", "emulate", "billing", "broadcast", "secrets", "compliance", "ops", "staff", "trial"];

export const STAFF = {
  page: "kairoo-staff-page",
  rolesTable: "kairoo-roles-table",
  usersTable: "kairoo-users-table",
  createRoleButton: "kairoo-create-role-button",
  createRoleDialog: "kairoo-create-role-dialog",
  roleNameInput: "kairoo-role-name-input",
  permissionCheckbox: (perm) => `kairoo-permission-checkbox-${perm}`,
  createRoleSubmit: "kairoo-create-role-submit-button",
  editPermissionsButton: (roleId) => `kairoo-edit-permissions-button-${roleId}`,
  editPermissionsDialog: "kairoo-edit-permissions-dialog",
  editConfirmInput: "kairoo-edit-permissions-confirm-input",
  editConfirmSubmit: "kairoo-edit-permissions-submit-button",
  createUserButton: "kairoo-create-user-button",
  createUserDialog: "kairoo-create-user-dialog",
  userNameInput: "kairoo-user-name-input",
  userEmailInput: "kairoo-user-email-input",
  userPasswordInput: "kairoo-user-password-input",
  userRoleSelect: "kairoo-user-role-select",
  createUserSubmit: "kairoo-create-user-submit-button",
  reassignRoleSelect: (userId) => `kairoo-reassign-role-select-${userId}`,
};

export const PLATFORM_OPS = {
  page: "platform-ops-page",
  healthCard: "platform-ops-health-card",
  orgStatusTable: "platform-ops-org-status-table",
  alertsTable: "platform-ops-alerts-table",
  ackButton: (id) => `platform-ops-ack-button-${id}`,
  acknowledgedFilter: "platform-ops-acknowledged-filter",
  createBackupButton: "platform-ops-create-backup-button",
  backupsTable: "platform-ops-backups-table",
  testRestoreButton: (dir) => `platform-ops-test-restore-button-${dir}`,
  testRestoreResult: "platform-ops-test-restore-result",
};

export const SETTINGS = {
  page: "settings-page",
  logoPreview: "settings-logo-preview",
  logoInput: "settings-logo-input",
  logoDeleteButton: "settings-logo-delete-button",
  legalNameInput: "settings-legal-name-input",
  phoneInput: "settings-phone-input",
  emailInput: "settings-email-input",
  addressLine1Input: "settings-address-line1-input",
  addressLine2Input: "settings-address-line2-input",
  cityInput: "settings-city-input",
  stateInput: "settings-state-input",
  pincodeInput: "settings-pincode-input",
  gstinInput: "settings-gstin-input",
  placeOfSupplyInput: "settings-place-of-supply-input",
  gstApplicableToggle: "settings-gst-applicable-toggle",
  gstRateInput: "settings-gst-rate-input",
  saveGstButton: "settings-save-gst-button",
  saveContactButton: "settings-save-contact-button",
  termsTextarea: "settings-terms-textarea",
  saveTermsButton: "settings-save-terms-button",
  integrationsSection: "settings-integrations-section",
  integrationRow: (id) => `settings-integration-row-${id}`,
  termsDefaultBadge: "settings-terms-default-badge",
};

export const SHELL = {
  sidebar: "app-sidebar",
  appShellLoading: "app-shell-loading",
  navItem: (key) => `nav-item-${key}`,
  logoMark: "app-logo-mark",
  topBar: "app-top-bar",
  searchInput: "global-search-input",
  // DEFECT-D-18: command-style quick actions inline in search results.
  searchQuickActionHint: "global-search-quick-action-hint",
  searchQuickCheckin: (id) => `global-search-quick-checkin-${id}`,
  searchQuickRenew: (id) => `global-search-quick-renew-${id}`,
  searchQuickMessage: (id) => `global-search-quick-message-${id}`,
  branchSwitcher: "branch-switcher-trigger",
  newMemberButton: "new-member-button",
  newMemberDialog: "new-member-dialog",
  newMemberNameInput: "new-member-name-input",
  newMemberPhoneInput: "new-member-phone-input",
  newMemberBranchSelect: "new-member-branch-select",
  newMemberNextButton: "new-member-next-button",
  newMemberError: "new-member-error",
  newMemberExistingFound: "new-member-existing-found",
  newMemberPlanSelect: "new-member-plan-select",
  newMemberStartDateInput: "new-member-start-date-input",
  newMemberDiscountInput: "new-member-discount-input",
  newMemberPlanNextButton: "new-member-plan-next-button",
  newMemberPaymentMode: "new-member-payment-mode",
  newMemberTxnRefInput: "new-member-txn-ref-input",
  newMemberPaymentAmount: "new-member-payment-amount-input",
  newMemberNetPayable: "new-member-net-payable",
  newMemberOutstandingBalance: "new-member-outstanding-balance",
  newMemberPaymentSubmit: "new-member-payment-submit-button",
  newMemberInvoiceButton: "new-member-invoice-button",
  newMemberPaymentContinueButton: "new-member-payment-continue-button",
  themeToggle: "theme-toggle-button",
  avatarMenuTrigger: "avatar-menu-trigger",
  avatarMenuLogout: "avatar-menu-logout-item",
  readOnlyBanner: "read-only-lapse-banner",
  idleWarning: "idle-timeout-warning",
};

export const COCKPIT = {
  page: "owner-cockpit-page",
  greeting: "cockpit-greeting",
  dateRangeSelect: "cockpit-date-range-select-trigger",
  kpiCard: (key) => `kpi-card-${key}`,
  occupancyWidget: "occupancy-widget",
  needsAttentionPanel: "needs-attention-panel",
  needsAttentionRow: (i) => `needs-attention-row-${i}`,
  membersTable: "recent-members-table",
  memberRow: (id) => `member-row-${id}`,
  emptyState: "cockpit-empty-state",
  errorState: "cockpit-error-state",
  errorCorrelationId: "cockpit-error-correlation-id",
  offlineBanner: "cockpit-offline-banner",
  quickActionsRow: "quick-actions-row",
  quickActionPin: (key) => `quick-action-pin-${key}`,
};

// Owner Cockpit's real Members list + detail (replaces the old StubPage) — the drill-down
// destination for the cockpit's "Active members"/"At-risk members" tiles, the Recent Members
// table, and the Needs Attention panel's `/app/members?highlight=` links.
// Lead Kanban pipeline — a SHARED module (not persona-specific) mounted at both `/desk/leads`
// (Front Desk/Manager) and `/app/leads` (Owner Cockpit, org-wide across branches). One set of
// test IDs since it's the literal same board/card/capture-form/convert-wizard components on
// both routes, not two parallel implementations.
export const LEADS = {
  page: "leads-page",
  captureButton: "leads-capture-button",
  captureBranchSelect: "leads-capture-branch-select",
  captureNameInput: "leads-capture-name-input",
  capturePhoneInput: "leads-capture-phone-input",
  captureEmailInput: "leads-capture-email-input",
  captureSourceSelect: "leads-capture-source-select",
  capturePlanSelect: "leads-capture-plan-select",
  captureFollowUpInput: "leads-capture-followup-input",
  captureNoteInput: "leads-capture-note-input",
  captureSubmitButton: "leads-capture-submit-button",

  // UX-CRM-03: 5 horizontal tabs (New Lead/Lead Pipeline/Contacted/Converted-Member/Lost) replaced
  // the earlier 5-column Kanban per explicit user request — each tab is an Excel-style table, a
  // row click opens the full-detail `LeadDetailDrawer` (see its own file for every field surfaced).
  tab: (key) => `leads-tab-${key}`,
  filterSearchInput: "leads-filter-search-input",
  filterSourceSelect: "leads-filter-source-select",
  filterBranchSelect: "leads-filter-branch-select",
  filterSubStatusSelect: "leads-filter-substatus-select",
  sortControl: "leads-sort-control",
  table: "leads-table",
  row: (id) => `leads-row-${id}`,
  rowSubStatusSelect: (id) => `leads-row-substatus-select-${id}`,
  rowMarkContactedButton: (id) => `leads-row-mark-contacted-button-${id}`,
  rowConvertButton: (id) => `leads-row-convert-button-${id}`,
  rowMarkLostButton: (id) => `leads-row-mark-lost-button-${id}`,
  rowReopenButton: (id) => `leads-row-reopen-button-${id}`,
  rowViewMemberButton: (id) => `leads-row-view-member-button-${id}`,
  rowOverdueBadge: (id) => `leads-row-overdue-badge-${id}`,
  contactedOverdueCount: "leads-contacted-overdue-count",
  emptyState: "leads-empty-state",

  detailDrawer: "leads-detail-drawer",
  detailStageSelect: "leads-detail-stage-select",
  detailFollowUpInput: "leads-detail-followup-input",
  detailNoteInput: "leads-detail-note-input",
  detailSaveButton: "leads-detail-save-button",
  detailConvertButton: "leads-detail-convert-button",
  detailMarkLostButton: "leads-detail-mark-lost-button",
  detailReopenButton: "leads-detail-reopen-button",

  convertWizard: "leads-convert-wizard",
  convertNameInput: "leads-convert-name-input",
  convertPersonalNextButton: "leads-convert-personal-next-button",
  convertPlanSelect: "leads-convert-plan-select",
  convertStartDateInput: "leads-convert-start-date-input",
  convertDiscountInput: "leads-convert-discount-input",
  convertPlanNextButton: "leads-convert-plan-next-button",
  convertSkipPlanButton: "leads-convert-skip-plan-button",
  convertPaymentMode: "leads-convert-payment-mode",
  convertTxnRefInput: "leads-convert-txn-ref-input",
  convertPaymentAmount: "leads-convert-payment-amount",
  convertNetPayable: "leads-convert-net-payable",
  convertOutstandingBalance: "leads-convert-outstanding-balance",
  convertPaymentSubmit: "leads-convert-payment-submit-button",
  convertInvoiceButton: "leads-convert-invoice-button",
  convertPaymentContinueButton: "leads-convert-payment-continue-button",
  convertHealthPage: "leads-convert-health-page",
};

export const OWNER_MEMBERS = {
  page: "owner-members-page",
  newMemberButton: "owner-members-new-button",
  searchInput: "owner-members-search-input",
  sortControl: "owner-members-sort-control",
  searchButton: "owner-members-search-button",
  filterTab: (key) => `owner-members-filter-${key}`,
  table: "owner-members-table",
  row: (id) => `owner-members-row-${id}`,
  emptyState: "owner-members-empty-state",
  detailPage: "owner-member-detail-page",
  detailBackLink: "owner-member-detail-back-link",
  editButton: "owner-member-edit-button",
  latestInvoiceButton: "owner-member-latest-invoice-button",
  addPlanButton: "owner-member-add-plan-button",
  reactivateOpenButton: "owner-member-reactivate-open-button",
  renewButton: (id) => `owner-member-renew-button-${id}`,
  freezeButton: (id) => `owner-member-freeze-button-${id}`,
  resumeButton: (id) => `owner-member-resume-button-${id}`,
  membershipRow: (id) => `owner-member-membership-row-${id}`,
  ledgerTable: "owner-member-ledger-table",
  // DEFECT-D-13/D-14: staff can link this member directly into an upcoming class.
  bookClassButton: "owner-member-book-class-button",
  bookClassDialog: "owner-member-book-class-dialog",
  bookClassSelect: "owner-member-book-class-select",
  bookClassConfirmButton: "owner-member-book-class-confirm-button",
  bookClassError: "owner-member-book-class-error",
};

// UX-GAP-01 §1.6: Owner Cockpit "Staff" — was a StubPage, now a real screen backed by the
// existing `/staff` CRUD + 2 new read-only endpoints (`/staff/seats`, `/staff/roles`).
export const ORG_STAFF = {
  page: "staff-page",
  seatGauge: "staff-seat-gauge",
  tab: (key) => `staff-tab-${key}`,
  addButton: "staff-add-button",
  sortControl: "staff-sort-control",
  table: "staff-table",
  row: (id) => `staff-row-${id}`,
  editButton: (id) => `staff-edit-button-${id}`,
  deactivateButton: (id) => `staff-deactivate-button-${id}`,
  reactivateButton: (id) => `staff-reactivate-button-${id}`,
  suspendButton: (id) => `staff-suspend-button-${id}`,
  unsuspendButton: (id) => `staff-unsuspend-button-${id}`,
  suspendDialog: "staff-suspend-dialog",
  suspendReasonInput: "staff-suspend-reason-input",
  suspendConfirmButton: "staff-suspend-confirm-button",
  emptyState: "staff-empty-state",
  roleCard: (name) => `staff-role-card-${name}`,

  formDialog: "staff-form-dialog",
  nameInput: "staff-name-input",
  emailInput: "staff-email-input",
  passwordInput: "staff-password-input",
  roleSelect: "staff-role-select",
  branchCheckbox: (id) => `staff-branch-checkbox-${id}`,
  statusSelect: "staff-status-select",
  formError: "staff-form-error",
  formSubmit: "staff-form-submit",
  seatLimitError: "staff-seat-limit-error",
  photoPreview: "staff-photo-preview",
  photoInput: "staff-photo-input",
  kycAadhaarInput: "staff-kyc-aadhaar-input",
  kycPanInput: "staff-kyc-pan-input",
  notesInput: "staff-notes-input",
};

// UX-GAP-01 §1.3: Owner Cockpit "Memberships & Plans" — was a StubPage. `PATCH /plans/{id}`
// creates a NEW version doc (old one untouched, existing memberships keep their pinned
// plan_ref/plan_version) rather than mutating in place — there is no plan-archive/deactivate
// endpoint, so Plans has no such button either.
export const PLANS = {
  page: "plans-page",
  tab: (key) => `plans-tab-${key}`,
  addPlanButton: "plans-add-plan-button",
  table: "plans-table",
  row: (id) => `plans-row-${id}`,
  editButton: (id) => `plans-edit-button-${id}`,
  deleteButton: (id) => `plans-delete-button-${id}`,
  deleteDialog: "plans-delete-dialog",
  deleteConfirmButton: "plans-delete-confirm-button",
  activeMemberCount: (id) => `plans-active-member-count-${id}`,
  sortControl: "plans-sort-control",
  emptyState: "plans-empty-state",

  formDialog: "plans-form-dialog",
  nameInput: "plans-name-input",
  typeSelect: "plans-type-select",
  amountInput: "plans-amount-input",
  joiningFeeInput: "plans-joining-fee-input",
  durationInput: "plans-duration-input",
  sessionsCapInput: "plans-sessions-cap-input",
  freezeMaxInput: "plans-freeze-max-input",
  freezeUnitSelect: "plans-freeze-unit-select",
  roamingCheckbox: "plans-roaming-checkbox",
  maxDiscountInput: "plans-max-discount-input",
  formError: "plans-form-error",
  formSubmit: "plans-form-submit",

  addPromoButton: "plans-add-promo-button",
  promoTable: "plans-promo-table",
  promoRow: (id) => `plans-promo-row-${id}`,
  promoFormDialog: "plans-promo-form-dialog",
  promoCodeInput: "plans-promo-code-input",
  promoDiscountInput: "plans-promo-discount-input",
  promoStartInput: "plans-promo-start-input",
  promoEndInput: "plans-promo-end-input",
  promoBranchCheckbox: (id) => `plans-promo-branch-checkbox-${id}`,
  promoFormError: "plans-promo-form-error",
  promoFormSubmit: "plans-promo-form-submit",
};

// UX-GAP-01 §1.4: Owner Cockpit "Money" — was a StubPage. 4 tabs against pre-existing endpoints:
// Overview (`/revenue/summary` + `/reconciliation/integrity-check`), Ledger (`/ledger`, filtered
// — no pagination param exists on that endpoint beyond a date range, so a date range defaulting
// to the last 7 days is the practical limiter), Refunds (same `/refunds` flow the Manager's
// "Refund approval" screen already uses — `payment.refund` sits on super_admin too), Invoices
// (read-only list + PDF re-download, reusing the exact `/invoices/{id}/pdf` link pattern
// `OwnerMemberDetail`'s "latest invoice" button already uses).
export const MONEY = {
  page: "money-page",
  tab: (key) => `money-tab-${key}`,

  revenueTile: "money-revenue-tile",
  netRevenueTile: "money-net-revenue-tile",
  refundsTile: "money-refunds-tile",
  duesTile: "money-dues-tile",
  integrityCheckButton: "money-integrity-check-button",
  integrityResult: "money-integrity-result",

  ledgerDateFrom: "money-ledger-date-from",
  ledgerDateTo: "money-ledger-date-to",
  ledgerTypeSelect: "money-ledger-type-select",
  ledgerSortControl: "money-ledger-sort-control",
  ledgerTable: "money-ledger-table",
  ledgerEmptyState: "money-ledger-empty-state",

  refundSearchInput: "money-refund-search-input",
  refundSearchButton: "money-refund-search-button",
  refundMemberRow: (id) => `money-refund-member-row-${id}`,
  refundEntryRow: (id) => `money-refund-entry-row-${id}`,
  refundButton: (id) => `money-refund-button-${id}`,
  refundAmountInput: "money-refund-amount-input",
  refundReasonInput: "money-refund-reason-input",
  refundConfirmInput: "money-refund-confirm-input",
  refundConfirmSubmit: "money-refund-confirm-submit",

  invoiceTable: "money-invoice-table",
  invoiceDownloadButton: (id) => `money-invoice-download-button-${id}`,
};

// UX-GAP-01 §1.9: Owner Cockpit "Revenue Extras" (module-gated on `loyalty`) — was a StubPage.
// Ad-revenue-share sub-widget is separately gated on `broadcast_os` and, even when that module
// is on, has NO real data-plane read endpoint (settlement/proof-of-play are Kairoo-only) — an
// honest "not connected" state per the doc's own "flag, don't fabricate" rule, not a fake chart.
export const REVENUE_EXTRAS = {
  page: "revenue-extras-page",
  tab: (key) => `revenue-extras-tab-${key}`,

  memberSearchInput: "revenue-extras-member-search-input",
  memberSearchButton: "revenue-extras-member-search-button",
  memberRow: (id) => `revenue-extras-member-row-${id}`,
  loyaltyPoints: "revenue-extras-loyalty-points",
  loyaltyTier: "revenue-extras-loyalty-tier",
  creditAmountInput: "revenue-extras-credit-amount-input",
  creditReasonInput: "revenue-extras-credit-reason-input",
  creditSubmit: "revenue-extras-credit-submit",

  referrerSearchInput: "revenue-extras-referrer-search-input",
  referrerRow: (id) => `revenue-extras-referrer-row-${id}`,
  referredNameInput: "revenue-extras-referred-name-input",
  referredPhoneInput: "revenue-extras-referred-phone-input",
  referralBranchSelect: "revenue-extras-referral-branch-select",
  referralSubmit: "revenue-extras-referral-submit",

  adRevenueNotConnected: "revenue-extras-ad-revenue-not-connected",
};

// UX-GAP-01 §1.10: Owner Cockpit "Retail" (module-gated on `retail`) — was a StubPage.
export const RETAIL = {
  page: "retail-page",
  tab: (key) => `retail-tab-${key}`,

  addProductButton: "retail-add-product-button",
  productTable: "retail-product-table",
  productRow: (id) => `retail-product-row-${id}`,
  productFormDialog: "retail-product-form-dialog",
  productNameInput: "retail-product-name-input",
  productCategorySelect: "retail-product-category-select",
  productPriceInput: "retail-product-price-input",
  productHsnInput: "retail-product-hsn-input",
  productFormError: "retail-product-form-error",
  productFormSubmit: "retail-product-form-submit",

  stockBranchSelect: "retail-stock-branch-select",
  restockButton: "retail-restock-button",
  stockTable: "retail-stock-table",
  stockRow: (id) => `retail-stock-row-${id}`,
  lowStockBadge: (id) => `retail-low-stock-badge-${id}`,
  restockFormDialog: "retail-restock-form-dialog",
  restockProductSelect: "retail-restock-product-select",
  restockQuantityInput: "retail-restock-quantity-input",
  restockThresholdInput: "retail-restock-threshold-input",
  restockFormSubmit: "retail-restock-form-submit",

  revenueBranchSelect: "retail-revenue-branch-select",
  revenueByCategory: "retail-revenue-by-category",
  marginNote: "retail-margin-note",
};

// UX-GAP-01 §1.5: Owner Cockpit "Operations" — was a StubPage. No per-event gate-log endpoint
// exists (`/metrics/leakage` only returns a denied-count, `/occupancy/live` only a live count) —
// the Access & Leakage tab surfaces exactly those 2 real aggregate numbers rather than
// fabricating a fake event-by-event log table.
export const OPERATIONS = {
  page: "operations-page",
  tab: (key) => `operations-tab-${key}`,

  branchSelect: "operations-branch-select",
  addClassButton: "operations-add-class-button",
  classTable: "operations-class-table",
  classRow: (id) => `operations-class-row-${id}`,
  classEmptyState: "operations-class-empty-state",

  classFormDialog: "operations-class-form-dialog",
  classTypeInput: "operations-class-type-input",
  classProviderSelect: "operations-class-provider-select",
  classCapacityInput: "operations-class-capacity-input",
  classStartInput: "operations-class-start-input",
  classEndInput: "operations-class-end-input",
  classFormError: "operations-class-form-error",
  classFormSubmit: "operations-class-form-submit",

  occupancyTile: "operations-occupancy-tile",
  leakageTile: "operations-leakage-tile",

  // DEFECT-D-13/D-14: staff can link a member directly into a class from its row.
  addMemberButton: (id) => `operations-add-member-button-${id}`,
  classSortControl: "operations-class-sort-control",
  addMemberDialog: "operations-add-member-dialog",
  addMemberSearchInput: "operations-add-member-search-input",
  addMemberResultRow: (id) => `operations-add-member-result-row-${id}`,
  addMemberConfirmButton: "operations-add-member-confirm-button",
  addMemberError: "operations-add-member-error",
};

// UX-GAP-01 §1.8: Owner Cockpit "Reports & Analytics" — was a StubPage. P&L/Expense/Retail-margin
// tabs are real (`routers/expense.py`). Cohort/retention analytics and cross-gym benchmarking
// have NO backend at all in this schema — an honest "not available" tab, not a fabricated chart.
export const REPORTS = {
  page: "reports-page",
  tab: (key) => `reports-tab-${key}`,
  branchSelect: "reports-branch-select",

  pnlRevenue: "reports-pnl-revenue",
  pnlExpense: "reports-pnl-expense",
  pnlProfit: "reports-pnl-profit",
  pnlTrendRow: (date) => `reports-pnl-trend-row-${date}`,

  expenseByCategory: "reports-expense-by-category",

  retailMarginTotal: "reports-retail-margin-total",
  retailMarginNote: "reports-retail-margin-note",

  cohortNotAvailable: "reports-cohort-not-available",
};
// UX-GAP-01 §1.7: Owner Cockpit "Branches" — was a StubPage. Backed by the pre-existing
// `/branches` CRUD, which only supports create + a single settings field
// (`auto_checkout_minutes`) — there's no rename/deactivate/address-edit endpoint in this schema,
// so this screen deliberately has NO such buttons rather than fabricating ones with nowhere to
// send the request.
export const BRANCHES = {
  page: "branches-page",
  addButton: "branches-add-button",
  table: "branches-table",
  row: (id) => `branches-row-${id}`,
  editSettingsButton: (id) => `branches-edit-settings-button-${id}`,
  emptyState: "branches-empty-state",

  formDialog: "branches-form-dialog",
  nameInput: "branches-name-input",
  formError: "branches-form-error",
  formSubmit: "branches-form-submit",

  settingsDialog: "branches-settings-dialog",
  autoCheckoutInput: "branches-auto-checkout-input",
  settingsSubmit: "branches-settings-submit",
  checkinModeSelect: "branches-checkin-mode-select",
  requirePresenceCheckbox: "branches-require-presence-checkbox",
  geofenceCheckbox: "branches-geofence-checkbox",
  geofenceLatInput: "branches-geofence-lat-input",
  geofenceLngInput: "branches-geofence-lng-input",
  geofenceRadiusInput: "branches-geofence-radius-input",
  // DEFECT-D-08
  nameEditInput: "branches-name-edit-input",
  addressInput: "branches-address-input",
  contactPhoneInput: "branches-contact-phone-input",
  gstinInput: "branches-gstin-input",
  statusSelect: "branches-status-select",
  notesInput: "branches-notes-input",
};

// UX-ONBOARD-01 — first-time onboarding tour (black spotlight overlay), one instance per
// persona shell (Owner Cockpit, Desk, Trainer, Member, Kairoo Control Plane).
export const ONBOARDING = {
  overlay: "onboarding-tour-overlay",
  tooltip: "onboarding-tour-tooltip",
  stepIndicator: "onboarding-tour-step-indicator",
  nextButton: "onboarding-tour-next-button",
  backButton: "onboarding-tour-back-button",
  skipButton: "onboarding-tour-skip-button",
  closeButton: "onboarding-tour-close-button",
  helpButton: "onboarding-tour-help-button",
};

export const EMULATOR = {
  entryPage: "emulator-entry-page",
  forbidden: "emulator-forbidden",
  gymSelect: "emulator-gym-select",
  personaSelect: "emulator-persona-select",
  personaOption: (persona) => `emulator-persona-option-${persona}`,
  reasonInput: "emulator-reason-input",
  enterButton: "emulator-enter-button",
  enterError: "emulator-enter-error",

  flagBar: "emulation-flag-bar",
  flagPersonaGym: "emulation-flag-persona-gym",
  flagOperator: "emulation-flag-operator",
  flagTimer: "emulation-flag-timer",
  exitButton: "emulation-exit-button",
  connectionsButton: "emulation-connections-button",
  connectionsDialog: "emulation-connections-dialog",
  escalateTrigger: "emulation-escalate-trigger",
  escalateItem: (key) => `emulation-escalate-item-${key}`,

  unavailablePage: "emulation-unavailable-page",
};


// UX-MEM-01: Member Light App — a completely separate persona (phone+OTP, mobile-first, dark
// "Tactical Minimalism" theme), so its own top-level test-id namespace.
export const MEMBER = {
  phoneInput: "member-phone-input",
  phoneSubmitButton: "member-phone-submit-button",
  otpInput: "member-otp-input",
  otpSubmitButton: "member-otp-submit-button",
  otpResendButton: "member-otp-resend-button",
  loginError: "member-login-error",
  loginBrand: "member-login-brand",

  navTab: (key) => `member-nav-tab-${key}`,

  homePage: "member-home-page",
  crowdMeter: "member-crowd-meter",
  offPeakCard: "member-off-peak-card",
  membershipBanner: "member-membership-banner",
  actionTileBook: "member-action-tile-book",
  actionTileShop: "member-action-tile-shop",
  checkinButton: "member-checkin-button",
  checkinResult: "member-checkin-result",
  checkinBranchSelect: "member-checkin-branch-select",
  checkinScanButton: "member-checkin-scan-button",
  checkinPinButton: "member-checkin-pin-button",
  checkinPinInput: "member-checkin-pin-input",
  checkinPinSubmit: "member-checkin-pin-submit",
  myQrButton: "member-my-qr-button",
  myQrCode: "member-my-qr-code",

  bookPage: "member-book-page",
  classRow: (id) => `member-class-row-${id}`,
  classBookButton: (id) => `member-class-book-button-${id}`,
  classCancelButton: (id) => `member-class-cancel-button-${id}`,
  myBookingsSection: "member-my-bookings-section",

  membershipPage: "member-membership-page",
  freezeButton: "member-freeze-button",
  freezeConfirmButton: "member-freeze-confirm-button",
  transferButton: "member-transfer-button",
  transferPhoneInput: "member-transfer-phone-input",
  transferReasonInput: "member-transfer-reason-input",
  transferConfirmButton: "member-transfer-confirm-button",
  payDuesButton: "member-pay-dues-button",
  renewButton: "member-renew-button",
  walletBalance: "member-wallet-balance",

  payPage: "member-pay-page",
  payAmountInput: "member-pay-amount-input",
  payRailInput: "member-pay-rail-input",
  paySubmitButton: "member-pay-submit-button",
  paySuccessScreen: "member-pay-success-screen",
  payFailureScreen: "member-pay-failure-screen",
  payBackButton: "member-pay-back-button",

  progressPage: "member-progress-page",
  progressEntry: (id) => `member-progress-entry-${id}`,
  progressMilestoneBadge: (id) => `member-progress-milestone-badge-${id}`,

  shopPage: "member-shop-page",
  shopDisabledMessage: "member-shop-disabled-message",
  productRow: (id) => `member-product-row-${id}`,
  productBuyButton: (id) => `member-product-buy-button-${id}`,

  morePage: "member-more-page",
  profileLink: "member-profile-link",
  profilePage: "member-profile-page",
  profileNameInput: "member-profile-name-input",
  profileEmailInput: "member-profile-email-input",
  profileWhatsappInput: "member-profile-whatsapp-input",
  profileDobInput: "member-profile-dob-input",
  profileGenderSelect: "member-profile-gender-select",
  profileBloodGroupInput: "member-profile-blood-group-input",
  profileAlternateMobileInput: "member-profile-alternate-mobile-input",
  profileOccupationInput: "member-profile-occupation-input",
  profileEmergencyNameInput: "member-profile-emergency-name-input",
  profileEmergencyRelationshipInput: "member-profile-emergency-relationship-input",
  profileEmergencyMobileInput: "member-profile-emergency-mobile-input",
  profileSaveButton: "member-profile-save-button",
  preferenceToggle: (channel, purpose) => `member-preference-toggle-${channel}-${purpose}`,
  consentToggle: (channel, purpose) => `member-consent-toggle-${channel}-${purpose}`,
  referralNameInput: "member-referral-name-input",
  referralPhoneInput: "member-referral-phone-input",
  referralSubmitButton: "member-referral-submit-button",
  testSendButton: "member-test-send-button",
  testSendResult: "member-test-send-result",
  whatsappHelpLink: "member-whatsapp-help-link",
  membershipLink: "member-membership-link",
  logoutButton: "member-logout-button",
};

// UX-TR-01: Trainer App — its own persona shell (`/trainer/*`), styled as a Desk-style flat
// "workhorse" surface (per the prompt's own note it's a between-sessions tool, not a showcase),
// not the Member App's dark glass theme.
export const TRAINER = {
  shell: "trainer-shell",
  navItem: (key) => `trainer-nav-${key}`,
  logoutButton: "trainer-logout-button",
  providerName: "trainer-provider-name",

  todayPage: "trainer-today-page",
  todaySessionRow: (id) => `trainer-today-session-row-${id}`,
  slippingClientRow: (ref) => `trainer-slipping-client-row-${ref}`,

  schedulePage: "trainer-schedule-page",
  scheduleSessionRow: (id) => `trainer-schedule-session-row-${id}`,
  attendButton: (id) => `trainer-attend-button-${id}`,
  noShowButton: (id) => `trainer-no-show-button-${id}`,
  waitlistRow: (ref) => `trainer-waitlist-row-${ref}`,

  availabilityPage: "trainer-availability-page",
  availabilityWindowRow: (i) => `trainer-availability-window-row-${i}`,
  availabilityDaySelect: "trainer-availability-day-select",
  availabilityStartInput: "trainer-availability-start-input",
  availabilityEndInput: "trainer-availability-end-input",
  availabilityAddWindowButton: "trainer-availability-add-window-button",
  availabilitySaveButton: "trainer-availability-save-button",

  clientsPage: "trainer-clients-page",
  clientRow: (id) => `trainer-client-row-${id}`,
  clientSlippingBadge: (id) => `trainer-client-slipping-badge-${id}`,

  clientDetailPage: "trainer-client-detail-page",
  clientDetailBackButton: "trainer-client-detail-back-button",
  progressTypeSelect: "trainer-progress-type-select",
  progressValueInput: "trainer-progress-value-input",
  progressUnitInput: "trainer-progress-unit-input",
  progressSubmitButton: "trainer-progress-submit-button",
  progressEntryRow: (id) => `trainer-progress-entry-row-${id}`,
  programStructureInput: "trainer-program-structure-input",
  programAssignButton: "trainer-program-assign-button",
  programRow: (id) => `trainer-program-row-${id}`,
  noteCategorySelect: "trainer-note-category-select",
  noteInput: "trainer-note-input",
  noteAddButton: "trainer-note-add-button",
  noteRow: (i) => `trainer-note-row-${i}`,
  messageClientButton: "trainer-message-client-button",

  earningsPage: "trainer-earnings-page",
  earningsTotalPaid: "trainer-earnings-total-paid",
  earningsPendingAmount: "trainer-earnings-pending-amount",
  earningsPayoutRunRow: (id) => `trainer-earnings-payout-run-row-${id}`,
  earningsPendingSessionRow: (id) => `trainer-earnings-pending-session-row-${id}`,

  performancePage: "trainer-performance-page",
  performanceSessionsStat: "trainer-performance-sessions-stat",
  performanceNoShowStat: "trainer-performance-no-show-stat",
  performanceRebookingStat: "trainer-performance-rebooking-stat",
  performanceAtRiskStat: "trainer-performance-at-risk-stat",

  messagePage: "trainer-message-page",
  messageClientSelect: "trainer-message-client-select",
  messageTextInput: "trainer-message-text-input",
  messageSendButton: "trainer-message-send-button",
  messageResult: "trainer-message-result",
};

// Shared "Full Profile & KYC" panel — mounted on BOTH the Owner Cockpit's MemberDetail.jsx and
// the Desk shell's MemberDetail.jsx (same component, two different pages/routes) so every
// persona with member.view (Owner, Manager, Front Desk) sees identical onboarding/KYC data.
// `prefix` keeps ids scoped per-page (`owner-member` / `desk-member`) since each page is its own
// route/testid namespace already (see OWNER_MEMBERS / DESK above).
export function memberProfileTestIds(prefix) {
  return {
    section: `${prefix}-profile-section`,
    toggle: `${prefix}-profile-toggle`,
    photo: `${prefix}-profile-photo`,
    dob: `${prefix}-profile-dob`,
    gender: `${prefix}-profile-gender`,
    bloodGroup: `${prefix}-profile-blood-group`,
    occupation: `${prefix}-profile-occupation`,
    alternateMobile: `${prefix}-profile-alternate-mobile`,
    whatsapp: `${prefix}-profile-whatsapp`,
    email: `${prefix}-profile-email`,
    emergencyContact: `${prefix}-profile-emergency-contact`,
    kycAadhaar: `${prefix}-profile-kyc-aadhaar`,
    kycPan: `${prefix}-profile-kyc-pan`,
    kycOtherDoc: `${prefix}-profile-kyc-other-doc`,
    medicalFlags: `${prefix}-profile-medical-flags`,
    notes: `${prefix}-profile-notes`,
    sourceAttribution: `${prefix}-profile-source`,
    memberSince: `${prefix}-profile-member-since`,
    lastVisit: `${prefix}-profile-last-visit`,
  };
}


// UX-P04 — Migration Studio (Implementation Team + Super Admin persona).
export const MIGRATION = {
  // SCR-P04-01 Home
  homePage: "migration-home-page",
  homeStartButton: "migration-home-start-button",
  homeToolsButton: "migration-home-tools-button",
  homeRow: (id) => `migration-home-row-${id}`,
  homeResumeButton: (id) => `migration-home-resume-button-${id}`,
  homeViewButton: (id) => `migration-home-view-button-${id}`,
  homeRollbackButton: (id) => `migration-home-rollback-button-${id}`,
  homeDiscardButton: (id) => `migration-home-discard-button-${id}`,
  rollbackConfirmInput: "migration-rollback-confirm-input",
  rollbackConfirmSubmit: "migration-rollback-confirm-submit-button",

  // Wizard shell (Steps 1-6)
  wizardPage: "migration-wizard-page",
  wizardStepLabel: (n) => `migration-wizard-step-${n}-label`,
  wizardBackButton: "migration-wizard-back-button",
  wizardContinueButton: "migration-wizard-continue-button",
  wizardSaveExitButton: "migration-wizard-save-exit-button",

  // SCR-P04-10 Upload
  uploadDropzone: "migration-upload-dropzone",
  uploadFileInput: "migration-upload-file-input",
  uploadFileRow: (name) => `migration-upload-file-row-${name}`,
  uploadFileRemove: (name) => `migration-upload-file-remove-${name}`,

  // SCR-P04-11 Map columns
  mapFileSelect: "migration-map-file-select",
  mapFieldSelect: (header) => `migration-map-field-select-${header}`,
  mapUnmappedWarning: "migration-map-unmapped-warning",

  // SCR-P04-12 Dedupe & clean
  dedupeGroupCard: (key) => `migration-dedupe-group-${key}`,
  dedupeActionSelect: (key) => `migration-dedupe-action-select-${key}`,
  bulkFillFieldSelect: "migration-bulkfill-field-select",
  bulkFillValueInput: "migration-bulkfill-value-input",
  bulkFillApplyButton: "migration-bulkfill-apply-button",

  // SCR-P04-13 Mid-cycle state
  midCycleField: (field) => `migration-midcycle-field-${field}`,
  midCycleSkipHistory: "migration-midcycle-skip-history",

  // SCR-P04-14 Preview
  previewCleanTile: "migration-preview-clean-tile",
  previewFlaggedTile: "migration-preview-flagged-tile",
  previewDuplicateTile: "migration-preview-duplicate-tile",
  previewFlaggedRow: (key) => `migration-preview-flagged-row-${key}`,
  previewFlaggedFixInput: (key, field) => `migration-preview-flagged-fix-${key}-${field}`,
  previewReRunButton: "migration-preview-rerun-button",

  // SCR-P04-15 Commit
  commitStartButton: "migration-commit-start-button",
  commitProgress: "migration-commit-progress",
  commitResultCommitted: "migration-commit-result-committed",
  commitResultSkipped: "migration-commit-result-skipped",
  commitResultErrors: "migration-commit-result-errors",
  commitRollbackButton: "migration-commit-rollback-button",
  commitDoneButton: "migration-commit-done-button",

  // Tools shell + tabs (SCR-P04-20/30/40/50/60)
  toolsPage: "migration-tools-page",
  toolsTab: (key) => `migration-tools-tab-${key}`,

  // SCR-P04-20 Re-mandate
  remandateMemberSearch: "migration-remandate-member-search",
  remandateMemberOption: (id) => `migration-remandate-member-option-${id}`,
  remandateSelectedChip: (id) => `migration-remandate-selected-chip-${id}`,
  remandateSendButton: "migration-remandate-send-button",
  remandateCampaignRow: (id) => `migration-remandate-campaign-row-${id}`,
  remandateAuthorizeButton: (memberRef) => `migration-remandate-authorize-button-${memberRef}`,

  // SCR-P04-30 Integration connect
  integrationWhatsappForm: "migration-integration-whatsapp-form",
  integrationWhatsappDisplayName: "migration-integration-whatsapp-display-name",
  integrationWhatsappNumber: "migration-integration-whatsapp-number",
  integrationWhatsappWabaId: "migration-integration-whatsapp-waba-id",
  integrationWhatsappPhoneId: "migration-integration-whatsapp-phone-id",
  integrationWhatsappToken: "migration-integration-whatsapp-token",
  integrationWhatsappSubmit: "migration-integration-whatsapp-submit-button",
  integrationWhatsappTest: "migration-integration-whatsapp-test-button",
  integrationPaymentForm: "migration-integration-payment-form",
  integrationPaymentProvider: "migration-integration-payment-provider",
  integrationPaymentDisplayName: "migration-integration-payment-display-name",
  integrationPaymentKey: "migration-integration-payment-key",
  integrationPaymentSubmit: "migration-integration-payment-submit-button",
  integrationPaymentTest: "migration-integration-payment-test-button",
  deviceLabelInput: "migration-device-label-input",
  deviceTypeSelect: "migration-device-type-select",
  deviceBranchSelect: "migration-device-branch-select",
  deviceTokenInput: "migration-device-token-input",
  deviceRegisterButton: "migration-device-register-button",
  deviceRow: (id) => `migration-device-row-${id}`,
  deviceTestButton: (id) => `migration-device-test-button-${id}`,

  // SCR-P04-40 Archetype
  archetypeApplyButton: "migration-archetype-apply-button",
  archetypeResultCreated: "migration-archetype-result-created",
  archetypeResultExisting: "migration-archetype-result-existing",

  // SCR-P04-50 Parallel run & go-live
  parallelBranchRow: (id) => `migration-parallel-branch-row-${id}`,
  parallelModeToggle: (id) => `migration-parallel-mode-toggle-${id}`,
  goLiveConfirmInput: "migration-golive-confirm-input",
  goLiveConfirmSubmit: "migration-golive-confirm-submit-button",

  // SCR-P04-60 Go-live checklist
  checklistIntegrations: "migration-checklist-integrations",
  checklistReconciliation: "migration-checklist-reconciliation",
  checklistRemandate: "migration-checklist-remandate",
  checklistGateStatus: "migration-checklist-gate-status",
};

// Marketing & Ads — new feature surface (/app/marketing), additive to every existing testId set.
export const MARKETING = {
  page: 'marketing-page',
  tab: (key) => `marketing-tab-${key}`,
  summaryActiveCampaigns: 'marketing-summary-active-campaigns',
  summarySpend: 'marketing-summary-spend',
  summaryLeads: 'marketing-summary-leads',
  summaryCpl: 'marketing-summary-cpl',
  summaryRoi: 'marketing-summary-roi',
  newCampaignButton: 'marketing-new-campaign-button',
  campaignRow: (id) => `marketing-campaign-row-${id}`,
  campaignPauseButton: (id) => `marketing-campaign-pause-${id}`,
  campaignResumeButton: (id) => `marketing-campaign-resume-${id}`,
  campaignPublishButton: (id) => `marketing-campaign-publish-${id}`,
  campaignPreviewToggle: (id) => `marketing-campaign-preview-${id}`,
  creativeAdd: 'marketing-creative-add',
  creativeHeadline: 'marketing-creative-headline',
  creativeBody: 'marketing-creative-body',
  creativeCta: 'marketing-creative-cta',
  creativeUrl: 'marketing-creative-url',
  creativeFileInput: 'marketing-creative-file-input',
  creativeUploadButton: 'marketing-creative-upload-button',
  creativeSave: 'marketing-creative-save',
  attributionHeadline: 'marketing-attribution-headline',
  attributionInsight: 'marketing-attribution-insight',
  attributionAlert: 'marketing-attribution-alert',
  attributionRow: (id) => `marketing-attribution-row-${id}`,
  templateCard: (id) => `marketing-template-${id}`,
  templateUseButton: (id) => `marketing-template-use-${id}`,
  ideaCategoryFilter: 'marketing-idea-category-filter',
  ideaSearchInput: 'marketing-idea-search-input',
  ideaRow: (id) => `marketing-idea-${id}`,
  wizardDialog: 'marketing-wizard-dialog',
  wizardName: 'marketing-wizard-name',
  wizardPlatform: 'marketing-wizard-platform',
  wizardObjective: 'marketing-wizard-objective',
  wizardBudget: 'marketing-wizard-budget',
  wizardStart: 'marketing-wizard-start',
  wizardEnd: 'marketing-wizard-end',
  wizardSubmit: 'marketing-wizard-submit',
  spendAmountInput: 'marketing-spend-amount-input',
  spendDateInput: 'marketing-spend-date-input',
  spendSubmit: 'marketing-spend-submit',
  adAccountLabelInput: 'marketing-ad-account-label-input',
  adAccountConnect: (p) => `marketing-ad-account-connect-${p}`,
  adAccountStatus: (p) => `marketing-ad-account-status-${p}`,
};
